









































import { ItemPriceRange } from "@/graphql/client";
import { Component, Emit, Vue } from "vue-property-decorator";
import itemPriceRangeService from "@/service/itemPriceRangeService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class ItemPriceRangeDeleteDialog extends Vue {
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: ItemPriceRange = itemPriceRangeService.defaultItemPriceRange;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * ダイアログを表示します.
   */
  public open(item: ItemPriceRange): void {
    this.item = item;

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  deleteItem(): void {
    this.isProgressing = true;
    //delete
    itemPriceRangeService
      .deleteItemPriceRange(this.item)
      .then((result) => {
        this.isProgressing = false;
        this.notifySuccess(result as ItemPriceRange);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  /**
   * 処理成功
   */
  @Emit("onSuccess")
  public notifySuccess(deleted: ItemPriceRange): ItemPriceRange {
    return deleted;
  }
}
